
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { TableNoLazy } from '@components/form';
import { formatCheck, formatDateDDMMYYYY } from '@components/common/format';
import { Column } from 'primereact/column';
import { SELECT_ANO_PECUARIO_FAZENDA } from '@handler';

class AnoPecuarioMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            modalAnoPecuarioOpen: false,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    componentDidMount() {
        if (this.props.startSessionReducer.configSession !== null && this.props.startSessionReducer.configSession !== undefined 
            && this.props.startSessionReducer.configSession.anosPecuario !== null && this.props.startSessionReducer.configSession.anosPecuario !== undefined
            && this.props.startSessionReducer.configSession.anosPecuario.length > 1 && this.props.startSessionReducer.configSession.anoPecuarioAtivo === null) {
            this.setState({
                modalAnoPecuarioOpen: true
            })
        }
    }

    render() {
        const { startSessionReducer } = this.props;

        function renderColumnAtivo(value) {
            return formatCheck(value.status);
        };

        function renderColumnDataInicial(value) {
            return formatDateDDMMYYYY(value.dataInicial);
        };

        function renderColumnDataFinal(value) {
            return formatDateDDMMYYYY(value.dataFinal);
        };

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" tag="button">
                        <i className="fa fa-calendar-check font-size-17" style={{ marginRight: '5px', color: '#175B28' }} />
                        <span style={{ color: '#175B28' }}>{startSessionReducer.configSession == null || startSessionReducer.configSession.anoPecuarioAtivo == null ?
                            "Nenhum Ano Selecionado  " : startSessionReducer.configSession.anoPecuarioAtivo.nome + "  "
                        }</span>
                        <i className="fa fa-angle-down" style={{ color: '#175B28' }} />
                    </DropdownToggle>
                    <DropdownMenu right>
                        {startSessionReducer.configSession == null || startSessionReducer.configSession.anosPecuario == null || startSessionReducer.configSession.anosPecuario.length <= 1 ?
                            <React.Fragment /> :
                            <React.Fragment>
                                <DropdownItem >
                                    <div onClick={() => this.setState({
                                        modalAnoPecuarioOpen: true
                                    })}>

                                        {startSessionReducer.configSession == null || startSessionReducer.configSession.anoPecuarioAtivo == null || startSessionReducer.configSession.anoPecuarioAtivo == null ?
                                            <i className="fa fa-check font-size-17 align-middle mr-1"></i> : <i className="fa fa-exchange-alt font-size-17 align-middle mr-1"></i>}
                                        {startSessionReducer.configSession == null || startSessionReducer.configSession.anoPecuarioAtivo == null || startSessionReducer.configSession.anoPecuarioAtivo == null ?
                                            "Acessar Ano" : "Trocar de Ano"}
                                    </div>
                                </DropdownItem>
                                <div className="dropdown-divider"></div>
                            </React.Fragment>
                        }
                        <DropdownItem tag="a" href="/pecuaria/anoPecuarioCadastro"><i className="mdi mdi-calendar font-size-17 align-middle mr-1"></i>Gerenciar Ano</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                {/* MODAL ATIVAR SAFRA */}
                <Modal isOpen={this.state.modalAnoPecuarioOpen} size="xl">
                    <ModalHeader>Acessar Ano Pecuário</ModalHeader>
                    <ModalBody>
                        <h4 className="font-size-18">Selecione o ano que você deseja acessar:</h4>

                        <TableNoLazy list={startSessionReducer.configSession.anosPecuario}>
                            <Column field='status' header='Ativo' body={renderColumnAtivo} style={{ textAlign: 'center', width: '100px' }} />

                            <Column field='nome' header='Nome' />

                            <Column field='dataInicial' header='Data Inicial' body={renderColumnDataInicial} style={{ textAlign: 'center', width: '150px' }} />

                            <Column field='dataFinal' header='Data Final' body={renderColumnDataFinal} style={{ textAlign: 'center', width: '150px' }} />

                            <Column style={{ textAlign: 'center', width: '20%' }}
                                body={(rowData, column) => {
                                    return (
                                        <div style={{ textAlign: 'center' }} >
                                            <Button onClick={() => this.props.selectAnoPecuarioFazenda(rowData.id)} >
                                                <i className='fa fa-check' /> Acessar Ano
                                            </Button>
                                        </div>
                                    );
                                }} />
                        </TableNoLazy>
                    </ModalBody>
                    {/* <ModalFooter>
                        <Button color="light" onClick={() => this.setState({
                            modalAnoPecuarioOpen: false
                        })} >Fechar</Button>
                    </ModalFooter> */}
                </Modal>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    const { startSessionReducer } = state.entities;
    return { startSessionReducer };
};

function mapDispatchToProps(dispatch) {
    return {
        selectAnoPecuarioFazenda: (id) => dispatch({ type: SELECT_ANO_PECUARIO_FAZENDA, id })
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AnoPecuarioMenu))




